<section class="page-section" id="login">
  <div class="extra-background">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Login</h2>
        </div>
      </div>
      <form [formGroup]="loginForm" (submit)="submitForm()">
        <mat-form-field appearance='outline'>
          <mat-label>Email</mat-label>
          <input matInput placeholder="enter email...." formControlName="email" name="email" type="email" />
        </mat-form-field>
        <mat-form-field appearance='outline'>
          <mat-label>password</mat-label>
          <input matInput type="password" placeholder="enter password...." formControlName="password" name="password"/>
        </mat-form-field>
        <button mat-ripple class="btn btn-fsp mb-3">Login</button>

        <a routerLink="/register" class="float-right">Register account</a>
        <br/>
        <a routerLink="/passwordreset">Forgot password</a>
      </form>
    </div>
  </div>
</section>
